import balanceAdjustments from '@/locales/en/accounting/balanceAdjustments.locales';
import externalProviders from '@/locales/en/accounting/externalProviders.locales';
import payments from '@/locales/en/accounting/payments.locales';
import providerPayroll from '@/locales/en/accounting/providerPayroll.locales';

export default {
    ...balanceAdjustments,
    ...payments,
    ...externalProviders,
    ...providerPayroll,
};
